"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div `
    &.psn {
        .ecr-success-header {
            li {
                align-items: flex-start;
                min-height: unset;
            }
            .right-part {
                li {
                    align-items: center;
                    h4 {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
`;
//# sourceMappingURL=PosaCardSuccessViewStyled.js.map